import React from 'react';
import { useSynapse } from 'app/lib/synaptik';
import { Drawer } from 'app/components/Drawer';
import Chat from './chat';

const ChatDrawer = () => {
  const [isChatOpen, toggleChat] = useSynapse(({ chat }) => [chat.state.isChatOpen, chat.toggleChat]);

  return (
    <Drawer isOpen={isChatOpen} onClose={toggleChat} headerText="Message Center">
      {isChatOpen && <Chat />}
    </Drawer>
  );
};

export default ChatDrawer;
